/*
 * Actions types
 */
export enum contactDPOTypes {
  CONTACT_DPO_RESQUEST = '@contactDPO/CONTACT_DPO_RESQUEST',
  CONTACT_DPO_SUCCESS = '@contactDPO/CONTACT_DPO_SUCCESS',
  CONTACT_DPO_FAILURE = '@contactDPO/CONTACT_DPO_FAILURE',
}

/*
 * State Type
 */
export interface contactDPOState {
  readonly data: any;
  readonly loading: boolean;
  readonly error: boolean;
}
